import React from 'react';
import { DesktopDateTimePicker } from '@mui/x-date-pickers';
import moment from 'moment-timezone';

import styles from './ATDateTimePicker.module.scss';
import { Button, Col, Row } from 'antd';
import { CloseCircleOutlined } from '@ant-design/icons';

interface ATDateTimePickerProps {
  value?: moment.Moment;
  onChange?: (value: moment.Moment) => void;
  disabled?: boolean;
  clearable?: boolean;
}

export const ATDateTimePicker: React.FC<ATDateTimePickerProps> = ({
  value,
  onChange,
  disabled = false,
  clearable = false,
}) => {
  const onClear = () => {
    if (!disabled) {
      onChange(null);
    }
  };

  return (
    <Row>
      <Col span={12}>
        <DesktopDateTimePicker
          className={styles.ATDateTimePicker}
          value={value}
          onChange={onChange}
          disabled={disabled}
          slotProps={{
            textField: { size: 'small' },
            inputAdornment: { sx: { right: '-10px' } },
            openPickerButton: { size: 'small' },
          }}
          format={'YYYY-MM-DD HH:mm'}
        />
      </Col>
      {clearable && !disabled && (
        <Col span={2} className={styles.ATDateTimePicker__clearBox} onClick={onClear}>
          <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
            <Button type="text" icon={<CloseCircleOutlined />} onClick={onClear} />
          </div>
        </Col>
      )}
    </Row>
  );
};
